import { Link, NavLink } from "react-router-dom";
import logo from "../assets/img/logo.png";
import Options from "../data/options";
import { useUser } from "../hooks/useUser";
import { useAuth } from "react-oidc-context";

const Sidebar = () => {
  const auth = useAuth();
  const options = Options.menu;

  const signOutRedirect = async () => {
    auth.removeUser()
    auth.signoutSilent()
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID
    const redirectUri = `${window.location.origin}`
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN
    const logoutUri = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(redirectUri)}`
    window.location.href = logoutUri
  }

  return (
    <nav id="sidebarMenu" className="d-lg-block">
      <div className="position-sticky mt-4">
        <div className="d-flex justify-content-center">
          <img src={logo} alt="" style={{ maxWidth: "200px" }} />
        </div>
        <div className="list-group list-group-flush mx-3 mt-4">
          {options.map((option, key) => (
            <NavLink
              to={option.path}
              key={key}
              className="list-group-item list-group-item-action py-2 ripple"
              id={"link" + key}
            >
              {option.name}
            </NavLink>
          ))}
          <Link
            to="#"
            className="list-group-item list-group-item-action py-2 ripple logout"
            onClick={() => signOutRedirect()}
          >
            Cerrar Sesión
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
